import { Button, Col, Row, Typography } from 'antd';
import { useEffect, useState } from 'react'
import { useParams, Link, useLocation } from 'react-router-dom';
import { UserOutlined, PhoneFilled, MailFilled, HomeFilled, LinkedinFilled, GlobalOutlined, CalendarOutlined, UsergroupAddOutlined, CommentOutlined, ContactsFilled } from "@ant-design/icons";
// UserOutlined, PhoneOutlined, MailOutlined, HomeOutlined
import service from '../../services/volunteerScientistService';
import { ReactComponent as LocationIcon } from "../../../src/assets/location-icon.svg";
import { ReactComponent as DisabilityIcon } from "../../../src/assets/disability-icon.svg";
import { Text } from '@react-pdf/renderer';

const { Title, Paragraph } = Typography;

export default function VolunteerScientistDetail() {
    let msg = "";
    const [demographics, setSetDemographics] = useState({});
    const [professionalExperience, setProfessionalExperience] = useState();
    const [volunteerism, setVolunteerism] = useState({});
    const [languages, setLanguages] = useState();

    const params = useParams();
    const location = useLocation();

    useEffect(() => {
        loadVolunteerData();
    }, [])

    const loadVolunteerData = async () => {
        try {
            const userId = params.id;
            const response = await service.getVolunteerScientist(userId);
            if (response && response.status == 200) {
                const { data } = response;
                setSetDemographics(data.demographics);
                var langs = data.demographics.languages.map(language => language.value);
                setLanguages(langs.join(', '));
                setProfessionalExperience(data.professionalExperience);
                setVolunteerism(data.volunteerism);
            } else {
                setSetDemographics({});
                setProfessionalExperience();
                setVolunteerism({});
            }
        } catch (error) {
            // recordError(error);
        }
    };


    // --- NEW: helper to normalize preferred communication from demographics
    const preferredCommunicationText = (() => {
        if (!demographics) return 'N/A';

        const flags = [
            demographics?.preferEmail ? 'Email' : null,
            demographics?.preferPhone ? 'Phone' : null,
        ].filter(Boolean);

        const fromArray = Array.isArray(demographics?.preferredCommunication)
            ? demographics.preferredCommunication
            : null;

        const fromString = typeof demographics?.preferredCommunication === 'string'
            ? demographics.preferredCommunication.split(',').map(s => s.trim()).filter(Boolean)
            : null;

        const mapToken = (t) => {
            switch (t) {
                case 'preferEmail':
                case 'email':
                    return 'Email';
                case 'preferPhone':
                case 'phone':
                    return 'Phone';
                default:
                    return t.charAt(0).toUpperCase() + t.slice(1);
            }
        };

        if (flags.length) return flags.join(', ');
        if (fromArray?.length) return fromArray.map(mapToken).join(', ');
        if (fromString?.length) return fromString.map(mapToken).join(', ');

        return 'N/A';
    })();


    return (
        <div className="cv-view">
            <Row >
                <Col xs={8} md={8} className="cv-view-left">
                    <div>
                        <div className="center-align">
                            {demographics.profilePicture && demographics.profilePicture.base64 ? (
                                <img
                                    // Construct the full Data URL using the type and base64 string
                                    src={`data:${demographics.profilePicture.type};base64,${demographics.profilePicture.base64}`}
                                    alt="profile"
                                    style={{ width: '80%', height: '80%', objectFit: 'cover' }}
                                />
                            ) : (
                                <UserOutlined style={{ fontSize: '60px', color: '#999' }} />
                            )}
                        </div>
                        <Row>
                            <Col xs={24}>
                                <Title level={3} style={{ textAlign: 'left', marginBottom: '24px', marginTop: '24px' }} className="heading">PERSONAL INFORMATION</Title>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} md={24}>
                                <UserOutlined style={{ fontSize: '110%', color: "#4e4e4e" }} /> &nbsp; {demographics?.title?.value} {demographics.firstName} {demographics.lastName}
                            </Col>
                        </Row>
                        <div className="space"></div>
                        <Row>
                            <Col xs={24} md={24}>
                                <PhoneFilled style={{ fontSize: '110%', color: "#4e4e4e" }} /> &nbsp; {demographics.contactNumber}
                            </Col>
                        </Row>
                        <div className="space"></div>
                        <Row>
                            <Col xs={24} md={24}>
                                <MailFilled style={{ fontSize: '110%', color: "#4e4e4e" }} /> &nbsp; {demographics.email}
                            </Col>
                        </Row>
                        <div className="space"></div>
                        <Row>
                            <Col xs={24} md={24}>
                                <CalendarOutlined style={{ fontSize: '110%', color: "#4e4e4e" }} /> &nbsp; {demographics.dateOfBirth}
                            </Col>
                        </Row>
                        <div className="space"></div>
                        <Row>
                            <Col xs={24} md={24}>
                                <UsergroupAddOutlined style={{ fontSize: '110%', color: "#4e4e4e" }} /> &nbsp; {demographics.race?.value}
                            </Col>
                        </Row>
                        <div className="space"></div>
                        <Row>
                            <Col xs={24} md={24}>
                                <DisabilityIcon style={{ fontSize: '130%', color: "#4e4e4e" }} /> &nbsp; {demographics.disability?.value}
                            </Col>
                        </Row>
                        <div className="space"></div>
                        <Row>
                            <Col xs={24} md={24}>
                                <CommentOutlined style={{ fontSize: '110%', color: "#4e4e4e" }} /> &nbsp; {languages}
                            </Col>
                        </Row>
                        <div className="space"></div>
                        <Row>
                            <Col xs={24} md={24}>
                                <HomeFilled style={{ fontSize: '110%', color: "#4e4e4e" }} /> &nbsp; {demographics.location?.town.value}
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={24} md={24}>
                                <div style={{ paddingLeft: '28px' }}>
                                    {demographics.location?.district.value}
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} md={24}>
                                <div style={{ paddingLeft: '28px' }}>
                                    {demographics.location?.province.value}
                                </div>
                            </Col>
                        </Row>
                        <div className="space"></div>
                        {professionalExperience?.linkedIn && (
                            <Row>
                                <Col xs={24} md={24}>
                                    <a href={`https://${professionalExperience.linkedIn.replace(/^(https?:\/\/)?(www\.)?/i, '')}`} target="_blank" rel="noopener noreferrer">
                                        <LinkedinFilled style={{ fontSize: '110%', color: "#4e4e4e" }} /> &nbsp; {professionalExperience.linkedIn}
                                    </a>
                                </Col>
                            </Row>
                        )}
                        <div className="space"></div>
                        {professionalExperience?.website && (
                            <Row>
                                <Col xs={24} md={24}>
                                    <a href={`https://${professionalExperience.website.replace(/^(https?:\/\/)?(www\.)?/i, '')}`} target="_blank" rel="noopener noreferrer">
                                        <GlobalOutlined style={{ fontSize: '110%', color: "#4e4e4e" }} /> &nbsp; {professionalExperience.website}
                                    </a>
                                </Col>
                            </Row>
                        )}
                    </div>
                    <div className="space"></div>
                    {demographics?.volunteerDifferentLocation && (
                        <Row>
                            <Col xs={24} md={24}>
                                <LocationIcon style={{ fontSize: '120%', color: "#4e4e4e" }} /> &nbsp; <Text strong>Open to volunteer outside their location? :</Text> {'Yes'}
                            </Col>
                        </Row>
                    )}
                    <div className='space'></div>
                    <Col xs={24} md={24}>
                        <ContactsFilled style={{ fontSize: '120%', color: "#4e4e4e" }} /> &nbsp; <Text strong>Preferred method of communication: </Text> {preferredCommunicationText}
                    </Col>
                </Col>

                <Col xs={16} md={16} className="cv-view-right">
                    <Row>
                        <Col xs={24}>
                            <Title level={3} style={{ textAlign: 'left', marginBottom: '24px' }} className="heading">PROFESSIONAL INFORMATION</Title>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24}>
                            <h3 className="left-align"><b>Biography</b></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24}>
                            <Paragraph style={{ textAlign: 'left' }}>
                                {professionalExperience?.about ? professionalExperience?.about : "No details provided"}
                            </Paragraph>
                        </Col>
                    </Row>
                    <div className="space"></div>
                    <Row>
                        <Col xs={24}>
                            <h3 className="left-align"><b>Qualification(s)</b></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col sx={24}>
                            {professionalExperience?.qualifications && professionalExperience?.qualifications.length > 0 ? (
                                professionalExperience?.qualifications.map((item, index) => (
                                    <p key={index}>
                                        {item?.qualification?.value}, {item?.field}, {item?.institution}
                                    </p>
                                ))
                            ) : (
                                <p>No qualifications to display.</p>
                            )}
                        </Col>
                    </Row>
                    <div className="space"></div>

                    <Row>
                        <Col xs={24}>
                            <h3 className="left-align"><b>Employment Status</b></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24}>
                            <Paragraph style={{ textAlign: 'left' }}>
                                {professionalExperience?.employmentStatus.value ? professionalExperience?.employmentStatus.value : "No details provided"}
                            </Paragraph>
                        </Col>
                    </Row>

                    {/* Conditional Check for Occupation, Specialisation, and Sector */}
                    {!(professionalExperience?.employmentStatus.value === 'Unemployed' || professionalExperience?.employmentStatus.value === 'Retired') && (
                        <>
                            {/* Occupation Title */}
                            <Row>
                                <Col xs={24}>
                                    <h3 className="left-align"><b>Occupation</b></h3>
                                </Col>
                            </Row>

                            {/* Occupation Value */}
                            <Row> <Col sx={24}><b>{professionalExperience?.occupation?.value}</b></Col></Row>

                            {/* Specialisation */}
                            <Row>Specialisation :&nbsp; <Col sx={24}>{professionalExperience?.specialisation ? professionalExperience?.specialisation : "No details provided"}</Col></Row>

                            {/* Sector */}
                            <Row>Sector :&nbsp; <Col sx={24}>{professionalExperience?.employment?.value ? professionalExperience?.employment?.value : "No details provided"}</Col></Row>
                        </>
                    )}
                    <div className="space"></div>
                    <Row>
                        <Col xs={24}>
                            <h3 className="left-align"><b>Professional Bodies or Volunteer Association(s)</b></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col sx={24}>
                            {/* Step 1: Filter out entries where both organisation and role are null */}
                            {/* Use optional chaining to safely get the array, or default to an empty array */}
                            {professionalExperience?.organisations
                                ?.filter(item => item?.organisation || item?.role) // Keep item if EITHER is truthy
                                .map((item, index) => (
                                    <p key={index}>
                                        {item?.organisation}, {item?.role}
                                    </p>
                                ))}

                            {/* Step 2: Fallback Check (Handle the case where the filter results in an empty array) */}
                            {!(professionalExperience?.organisations
                                ?.filter(item => item?.organisation || item?.role)
                                .length) && (
                                    <p>No details provided.</p>
                                )}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24}>
                            <Title level={3} style={{ textAlign: 'left', marginBottom: '24px', marginTop: '34px' }} className="heading">VOLUNTEERISM INFORMATION</Title>
                        </Col>
                    </Row>
                    <Row>
                        <Col sx={24}>
                            <h3 className="left-align"><b>Preferred Volunteer Role(s)</b></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col sx={24}>
                            {volunteerism.preferredRoles ?
                                <ul>
                                    {(
                                        volunteerism.preferredRoles.map((role) => (
                                            <li key={role.key}>
                                                {role.value} {role.value == "Other" && volunteerism.otherRole && (
                                                    <span> ({volunteerism.otherRole})</span>
                                                )}
                                            </li>
                                        ))
                                    )}
                                </ul> : (
                                    ''
                                )}
                        </Col>
                    </Row>
                    <div className="space"></div>
                    <Row>
                        <Col sx={24}>
                            <h3 className="left-align"><b>Reason(s) for Volunteering</b></h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col sx={24}>
                            {volunteerism.reasons ?
                                <ul>
                                    {(
                                        volunteerism.reasons.map((role) => (
                                            <li key={role.key}>
                                                {role.value} {role.value == "Other" && volunteerism.otherReason && (
                                                    <span> ({volunteerism.otherReason})</span>
                                                )}

                                            </li>

                                        ))
                                    )}
                                </ul> : (
                                    ''
                                )}
                        </Col>
                    </Row>
                    <div className="space"></div>
                    <Row>
                        <Col xs={24} md={24} className="right-align">
                            <Link key="2" to='/volunteer-scientist'
                                state={location.state} >
                                <Button className="right-align-button" type="primary" style={{ marginLeft: 10, marginTop: "20px" }}>
                                    Back
                                </Button>
                            </Link>
                        </Col>
                    </Row>
                </Col>
            </Row >

        </div >
    )
}
